import config from "@/config"
import http from "@/utils/request"

// 抽奖活动管理（文件名即一级分组：$API.lottery.xxx）
export default {
	// 活动列表（分页，附参与统计与活动阶段）
	index: {
		url: `${config.API_URL}/bwmall/admin/activity/lottery/index`,
		name: "抽奖活动列表",
		get: async function(data={}){
			return await http.get(this.url, data);
		}
	},
	// 活动详情（含奖品列表，编辑回显用；id 为活动ID）
	detail: {
		url: `${config.API_URL}/bwmall/admin/activity/lottery/detail/`,
		name: "抽奖活动详情",
		get: async function(id){
			return await http.get(this.url + id);
		}
	},
	// 新建活动（含奖品配置）
	add: {
		url: `${config.API_URL}/bwmall/admin/activity/lottery/add`,
		name: "创建抽奖活动",
		post: async function(data={}){
			return await http.post(this.url, data);
		}
	},
	// 编辑活动（奖品差量同步；id 为活动ID）
	edit: {
		url: `${config.API_URL}/bwmall/admin/activity/lottery/edit/`,
		name: "编辑抽奖活动",
		post: async function(id, data={}){
			return await http.post(this.url + id, data);
		}
	},
	// 删除活动（软删，id 支持数组批量）
	del: {
		url: `${config.API_URL}/bwmall/admin/activity/lottery/del`,
		name: "删除抽奖活动",
		post: async function(data={}){
			return await http.post(this.url, data);
		}
	},
	// 启用/停用活动
	status: {
		url: `${config.API_URL}/bwmall/admin/activity/lottery/status`,
		name: "抽奖活动启停",
		post: async function(data={}){
			return await http.post(this.url, data);
		}
	},
	// 抽奖配置数据（启用中活动选项 + 当前默认活动）
	config: {
		url: `${config.API_URL}/bwmall/admin/activity/lottery/config`,
		name: "抽奖配置数据",
		get: async function(data={}){
			return await http.get(this.url, data);
		}
	},
	// 保存默认抽奖活动
	configSave: {
		url: `${config.API_URL}/bwmall/admin/activity/lottery/configSave`,
		name: "保存抽奖配置",
		post: async function(data={}){
			return await http.post(this.url, data);
		}
	}
}
